/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.Decision = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The Decision model module.
   * @module model/Decision
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>Decision</code>.
   * @alias module:model/Decision
   * @class
   */
  var exports = function() {
    var _this = this;




















  };

  /**
   * Constructs a <code>Decision</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Decision} obj Optional instance to populate.
   * @return {module:model/Decision} The populated <code>Decision</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('DecisionTopicID')) {
        obj['DecisionTopicID'] = ApiClient.convertToType(data['DecisionTopicID'], 'Integer');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('Reason')) {
        obj['Reason'] = ApiClient.convertToType(data['Reason'], 'String');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('CreatedBy')) {
        obj['CreatedBy'] = ApiClient.convertToType(data['CreatedBy'], 'Integer');
      }
      if (data.hasOwnProperty('FollowUpByUserID')) {
        obj['FollowUpByUserID'] = ApiClient.convertToType(data['FollowUpByUserID'], 'Integer');
      }
      if (data.hasOwnProperty('StatusID')) {
        obj['StatusID'] = ApiClient.convertToType(data['StatusID'], 'Integer');
      }
      if (data.hasOwnProperty('ClosedDate')) {
        obj['ClosedDate'] = ApiClient.convertToType(data['ClosedDate'], 'Date');
      }
      if (data.hasOwnProperty('FollowUpMessage')) {
        obj['FollowUpMessage'] = ApiClient.convertToType(data['FollowUpMessage'], 'String');
      }
      if (data.hasOwnProperty('MeetingSectionTopicID')) {
        obj['MeetingSectionTopicID'] = ApiClient.convertToType(data['MeetingSectionTopicID'], 'Integer');
      }
      if (data.hasOwnProperty('TrackingTypeID')) {
        obj['TrackingTypeID'] = ApiClient.convertToType(data['TrackingTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategicGoalMilestoneID')) {
        obj['StrategicGoalMilestoneID'] = ApiClient.convertToType(data['StrategicGoalMilestoneID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategicProgramID')) {
        obj['StrategicProgramID'] = ApiClient.convertToType(data['StrategicProgramID'], 'Integer');
      }
      if (data.hasOwnProperty('ClosedBy')) {
        obj['ClosedBy'] = ApiClient.convertToType(data['ClosedBy'], 'Integer');
      }
      if (data.hasOwnProperty('ClosedComment')) {
        obj['ClosedComment'] = ApiClient.convertToType(data['ClosedComment'], 'String');
      }
      if (data.hasOwnProperty('DueDate')) {
        obj['DueDate'] = ApiClient.convertToType(data['DueDate'], 'Date');
      }
      if (data.hasOwnProperty('ClosedAtMeetingID')) {
        obj['ClosedAtMeetingID'] = ApiClient.convertToType(data['ClosedAtMeetingID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategicGoalID')) {
        obj['StrategicGoalID'] = ApiClient.convertToType(data['StrategicGoalID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} DecisionTopicID
   */
  exports.prototype['DecisionTopicID'] = undefined;
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {String} Reason
   * @default ''
   */
  exports.prototype['Reason'] = '';
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} CreatedBy
   * @default 0
   */
  exports.prototype['CreatedBy'] = 0;
  /**
   * @member {Integer} FollowUpByUserID
   */
  exports.prototype['FollowUpByUserID'] = undefined;
  /**
   * @member {Integer} StatusID
   * @default 0
   */
  exports.prototype['StatusID'] = 0;
  /**
   * @member {Date} ClosedDate
   */
  exports.prototype['ClosedDate'] = undefined;
  /**
   * @member {String} FollowUpMessage
   * @default ''
   */
  exports.prototype['FollowUpMessage'] = '';
  /**
   * @member {Integer} MeetingSectionTopicID
   */
  exports.prototype['MeetingSectionTopicID'] = undefined;
  /**
   * @member {Integer} TrackingTypeID
   * @default 0
   */
  exports.prototype['TrackingTypeID'] = 0;
  /**
   * @member {Integer} StrategicGoalMilestoneID
   */
  exports.prototype['StrategicGoalMilestoneID'] = undefined;
  /**
   * @member {Integer} StrategicProgramID
   */
  exports.prototype['StrategicProgramID'] = undefined;
  /**
   * @member {Integer} ClosedBy
   */
  exports.prototype['ClosedBy'] = undefined;
  /**
   * @member {String} ClosedComment
   * @default ''
   */
  exports.prototype['ClosedComment'] = '';
  /**
   * @member {Date} DueDate
   */
  exports.prototype['DueDate'] = undefined;
  /**
   * @member {Integer} ClosedAtMeetingID
   */
  exports.prototype['ClosedAtMeetingID'] = undefined;
  /**
   * @member {Integer} StrategicGoalID
   */
  exports.prototype['StrategicGoalID'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


